import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "./client";

export interface PrimeOut {
  onboarded: boolean;
  primed_symbol: string | null;
}

export function useOnboardingPrime() {
  const qc = useQueryClient();
  return useMutation<PrimeOut, Error, void>({
    mutationFn: async () => (await api.post<PrimeOut>("/onboarding/prime")).data,
    onSuccess: () => {
      // /me serves the onboarded flag — refetch so the overlay closes.
      qc.invalidateQueries({ queryKey: ["me"] });
    },
  });
}
